module.exports = __webpack_public_path__ + "img/step5-fr.df95f2c8.webp";